import { transformRoutes } from '../utils'

const baseRoute = '/accidents'

export const BaseAccidentsReportsAreaRoutes = {
  route: baseRoute,
  ViewReport: {
    route: '/:reportId/view',
  },
  NotFound: {
    route: '/not-found',
  },
}

export const AccidentsReportsAreaRoutes = transformRoutes(
  BaseAccidentsReportsAreaRoutes,
)
